<script lang="ts" setup>
const { goTo = 'login' } = defineProps<{ goTo?: 'login' | 'register' }>();
</script>

<template>
  <div class="login-or-register">
    <template v-if="goTo === 'login'">
      <span>Already have an account? </span>
      <NuxtLink to="/auth/login" class="text-color-brand ml-1 font-bold"
        >Login</NuxtLink
      >
    </template>
    <template v-else>
      <span>Don't have an account yet?</span>
      <NuxtLink to="/auth/register" class="text-color-brand ml-1 font-bold"
        >Sign Up</NuxtLink
      >
    </template>
  </div>
</template>

<style lang="scss" scoped>
.login-or-register {
}
</style>
